<template>
  <div class="regulation-main form-wrapper">
    <div class="form-fields-wrapper">
      <div class="pb-28">
        <p class="m-0 regulation_check">{{ $t("identifyRequirements") }}</p>
      </div>
      <div class="col-xs-12 pl-10">
        <div style="position:relative">
          <search-box  v-model="searchValue" :searchCount="searchCount" @getList="filterRegulationsList"></search-box>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 regulationBackground pl-10" >
      <div class="">
        <table class="table table-responsive" id="regulationDataList">
            <tr style="background-color: #E6E6E6; !important;">
              <th class="pl-16" style="width:40px" :class="{'disable-content': disableCheck }">
                <div class="checkbox-wrapper">
                  <label class="custom-checkbox">
                    <input type="checkbox" class="form-control" v-model="isAllRegulationCheck" @change="setAllRegulationCheck" />
                    <span class="select-check"></span>
                  </label>
                </div>
              </th>
              <th style="width: 35%;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.regulationName = -(arrowDirection.regulationName), sortBy('regulationName', arrowDirection.regulationName)">
                  <div class="ellipsis header-title" :title="$t('regulationName')">{{$t('regulationName')}}</div>
                  <div class="arrow" :class="arrowDirection.regulationName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: 20%;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.norm = -(arrowDirection.norm), sortBy('normName', arrowDirection. norm)">
                  <div class="ellipsis header-title" :title="$t('norm')">{{$t('norm')}}</div>
                  <div class="arrow" :class="arrowDirection.norm === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: auto;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.normType = -(arrowDirection.normType), sortBy('normType', arrowDirection.normType)">
                  <div class="ellipsis header-title" :title="$t('normType')">{{$t('normType')}}</div>
                  <div class="arrow" :class="arrowDirection.normType === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th style="width: 28%;">
                <div class="tableHeader cursor-pointer" @click="arrowDirection.link = -(arrowDirection.link), sortBy('link', arrowDirection. link)">
                  <div class="ellipsis header-title" :title="$t('link')">{{$t('link')}}</div>
                  <div class="arrow" :class="arrowDirection.link === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
            </tr>
          <tbody ref="tbodyBox" v-if="renderFilterData && renderFilterData.length">
            <tr
             :class="selectedRegulationCheck.includes(data)?'selected_row':index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(data, index) in renderFilterData" :key="index">
              <td style="width:40px" class="pl-16 pt-16">
                <div class="checkbox-wrapper" :class="{'disable-content': disableCheck}">
                  <label class="custom-checkbox">
                    <input type="checkbox" @click="deselect" :value="data" v-model="selectedRegulationCheck" />
                    <span class="select-check"></span>
                  </label>
                </div>
              </td>
              <td style="width: 35%;" class="ellipsis regulation-data"><span :title="data.regulationName">{{ data.regulationName }}</span></td>
              <td style="width: 20%;" class="ellipsis regulation-data"><span :title="data.normName">{{ data. normName }}</span></td>
              <td style="width: auto;" class="ellipsis regulation-data"><span :title="data.normType">{{ data.normType }}</span></td>
              <td style="width: 28%;" class="ellipsis regulation-data"><span :title="data.link"><a style="color:#00518A;" target="_blank" :href="data.link">{{ data. link }}</a></span></td>
             </tr>
          </tbody>
        </table>
        <div v-if="!renderFilterData.length">
              <p class="no-records-found">{{$t('noRecordsFound')}}</p>
            </div>
      </div>
    </div>
    <!-- <div class="col-xs-12 footer p-0" v-if="renderFilterData && renderFilterData.length > 0">

           <button v-if="roleId!==3" type="button" class="btn ul_finish_button" @click="addToChecklist()" >
           <span class="seeMore pr-8" >{{ $t('finish') }}</span>

          </button>

      </div> -->
    <loader :loadingStatus="loaderStatus"></loader>

    </div>
  </div>
</template>
<script>
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/ULSearchBox.vue';
import {
  getProductRegulations,
  addToChecklist,
  isRegulationChecked,

} from '../../apis/regulationCheck';

export default {
  props: { nextBtn: String },
  components: {
    SearchBox,
    Loader,
    EventBus,
  },
  data() {
    return {
      searchValue: '',
      renderFilterData: [],
      disableCheck: false,
      arrowDirection: {
        product_name: 1,
        regulationName: 1,
        normType: 1,
        action_type: 1,
        norm: 1,
        link: 1,
      },
      searchCount: 0,
      filteredRegulationData: [],
      loaderStatus: true,
      isRegistrationCheckComplete: '',
      regulationInfo: '',
      regulationData: [],
      isPreviouslySearched: false,
      roleId: '',
      isAllRegulationCheck: false,
      selectedRegulationCheck: [],
    };
  },
  watch: {
    selectedRegulationCheck() {
      if (this.selectedRegulationCheck.length === this.renderFilterData.length) this.$emit('disableSaveBtn', false);
      else this.$emit('disableSaveBtn', true);
    },
    nextBtn() {
      if (this.nextBtn === 'regulation') {
      // perform add regulation check
        if (!this.disableCheck) this.addToChecklist();
        else {
          this.$emit('submit');
          this.$router.push(`/layout/registration/flow/provide-evidence/${this.$route.params.id}`);
        }
      }
    },
  },
  methods: {
    async getRegulations() {
      // const isNewToMarket = this.$route.params && this.$route.params.id;
      const response = await getProductRegulations(this.$route.params.type_id, this.$route.params.id);
      if (response) {
        this.renderFilterData = response.data;
        this.selectedRegulationCheck = this.renderFilterData.filter((item) => item.status === 'Completed' || item.status === 'Concluído');
        if (this.renderFilterData && this.renderFilterData.filter((item) => item.status === 'Completed' || item.status === 'Concluído').length) this.disableCheck = true;
        if (this.selectedRegulationCheck && this.selectedRegulationCheck.length === this.renderFilterData.length) this.isAllRegulationCheck = true;
        this.loaderStatus = false;
        if (this.renderFilterData) {
          this.filteredRegulationData = this.renderFilterData;
          this.searchCount = this.renderFilterData.length;
        }
      }
    },
    setAllRegulationCheck(event) {
      if (!event.target.checked) {
        this.isAllRegulationCheck = false;
      }
      if (this.isAllRegulationCheck) this.selectedRegulationCheck = this.renderFilterData;
      else this.selectedRegulationCheck = [];
    },
    deselect(event) {
      if (!event.target.checked) {
        this.isAllRegulationCheck = false;
      } else if (event.target.checked && this.selectedRegulationCheck.length + 1 === this.renderFilterData.length) {
        this.isAllRegulationCheck = true;
      }
    },
    sortBy(type, direction) {
      if (direction === 1) this.renderFilterData.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.renderFilterData.sort((a, b) => {
          if (a[type] === null) {
            a[type] = '';
          } else if (b[type] === null) {
            b[type] = '';
          }
          const firstElement = a[type].toUpperCase(); // ignore upper and lowercase
          const secondElement = b[type].toUpperCase(); // ignore upper and lowercase

          if (firstElement < secondElement) {
            return -1;
          }
          if (firstElement > secondElement) {
            return 1;
          }
          return 0;
        });
      }
    },
    filterRegulationsList() {
      if (this.searchValue) {
        this.filterRegulations();
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterRegulations();
        this.isPreviouslySearched = false;
      }
    },
    async filterRegulations() {
      const searchStr = this.searchValue.trim();

      this.renderFilterData = [];
      if (!searchStr.length) {
        this.renderFilterData = this.filteredRegulationData;
        this.searchCount = this.renderFilterData.length;
        return;
      }
      this.renderFilterData = this.filteredRegulationData.filter((each) => this.searchString(searchStr, each));
      this.searchCount = this.renderFilterData.length;
    },
    searchString(searchValue, regulationsData) {
      if ((regulationsData.product_name.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((regulationsData.regulationName.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((regulationsData.normType.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((regulationsData.normName.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((regulationsData.link.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    },
    addItem(regulationIndex, data) {
      const response = this.regulationData.findIndex((item) => item.registration_id === data.registration_id);
      if (response === -1) {
        const toDoList = { regulation_id: data.regulation_id, norm_list: [] };
        toDoList.norm_list.push(data.norm_id);
        const toDoListArray = [];
        toDoListArray.push(toDoList);
        const payload = { registration_id: data.registration_id, to_do_check_list: toDoListArray, registration_type: data.registration_type_id };
        this.regulationData.push(payload);
      } else {
        const result = this.regulationData[response].to_do_check_list.findIndex((item) => item.regulation_id === data.regulation_id);
        if (result === -1) {
          const normList = [];
          normList.push(data.norm_id);
          this.regulationData[response].to_do_check_list.push({ regulation_id: data.regulation_id, norm_list: normList });
        } else {
          this.regulationData[response].to_do_check_list[result].norm_list.push(data.norm_id);
        }
      }
      data.is_disable = true;
      this.renderFilterData.splice(regulationIndex, 1, data);
    },
    async addToChecklist() {
      const response = await addToChecklist({ data: this.selectedRegulationCheck });

      if (response.status_code === 200) {
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: response.message,
          group: 'custom-notification',
        });
        if (this.$route.params && this.$route.params.id) {
          this.$emit('submit');
          this.$router.push(`/layout/registration/flow/provide-evidence/${this.$route.params.id}`);
        }
        // else this.$router.push('todo-list');
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.message,
          group: 'custom-notification',
        });
      }
    },
    async isRegulationChecked() {
      const response = await isRegulationChecked();
      if (response.status_code === 200) {
        this.regulationInfo = response;
        this.isRegistrationCheckComplete = response.isRegistrationCheckComplete;
      }
    },
  },
  async created() {
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    await this.getRegulations();
  },
  beforeDestroy() {
    EventBus.$off('updateLanguage');
  },

};
</script>
<style scoped>
.selected_row {
  background: #ECF5FC;
}
.footer {
  text-align: right;
  padding-right: 25px;
  padding-bottom: 20px;
  background-color: #ebebeb !important;
}
.ul_finish_button,
.ul_finish_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF !important;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 16px 6px 16px;
}
.btn-todo-list,
.btn-todo-list:hover {
  background: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A;
  /* padding-bottom: 4px; */
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.form-fields-wrapper {
  border: 1px solid #b3b3b3;
  background: #fff;
  min-height: 85vh;
  padding: 45px 23px 24px 35px;
}
.pb-28 {
  padding-bottom: 28px;
}
.pb-14 {
  padding-bottom: 14px;
}
.pl-16 {
  padding-left: 16px !important;
}
.pt-16 {
  padding-top: 16px !important;
}

.p-40 {
  padding: 40px;
}
.header-title{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 12px !important;
}
.emergo-table th:first-child {
  padding-left: 12px !important;
}
.emergo-table.table tbody td:first-child {
   padding: 14px 14px 16px 12px !important;
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.regulation-main {
  display: inline-flex;
  padding: 32px 40px 24px 40px;
}
.regulation_check {
  font-weight: 600;
  font-size: 18px;
  line-height: normal;
  color: #3E3E3E;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 12px;
  column-gap: 7px
  /* justify-content: center; */
}
#regulationDataList th .arrow {
  opacity: 1;
}
#regulationDataList thead,

#regulationDataList tbody,

#regulationDataList tr:not(#regulationDataList thead tr) {
 display: table;
 width: 100%;
  table-layout: fixed;
}
</style>
